// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// import * as fundebug from "fundebug-javascript";
// import fundebugVue from "fundebug-vue";
// import  './KEY'
// fundebugVue(fundebug, Vue);
import Es6Promise from "es6-promise";
require("es6-promise").polyfill();
Es6Promise.polyfill();
// import "@babel/polyfill";
import 'babel-polyfill'
import App from "./App";
import router from "./router";
import store from "./store/";
import NProgress from "nprogress";
// import FastClick from "fastclick";
// import VeeValidate from "vee-validate";
import Navigation from "vue-navigation";
import "nprogress/nprogress.css";
import 'swiper/dist/css/swiper.css'
import "./sass/index.scss";
import "lib-flexible/flexible.js";
import baseMixin from "./units/baseMixin.js";
import baseUrl from "./units/baseUrl.js";
import "vant/lib/index.css";
import * as filters from "@/units/filter";
import $axios from "axios";
import version from  "../static/version.json";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.use(Navigation, { router });
// Vue.use(VeeValidate);
Vue.mixin(baseMixin);
import {
  Tabbar,
  TabbarItem,
  Lazyload,
  Loading,
  Dialog,
  Toast
} from "vant";
Vue.use(Tabbar).use(TabbarItem).use(Lazyload, {
    preLoad: 2,
    error: require("./assets/images/error_img.png"),
    loading: require("./assets/images/error_img.png"),
    attempt: 1
  }).use(Loading).use(Dialog).use(Toast);
import eicon from "./components/icon";
import eheader from "./components/header";
import efooter from "./components/footer";
import { isWeiXin } from "./units/common";
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });
Vue.component("e-icon", eicon);
Vue.component("e-header", eheader);
Vue.component("e-footer", efooter);

var routerList = [];
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  store.commit("SAVE_BACK", from.fullPath);
  $axios.get('./static/version.json?_=' + Math.random()).then(response => {
    if ( response.status == '200') {
        if (process.env.VERSION !== response.data.version) {
            window.location.reload(true);
            return;
        }
        next();
    }
  }).catch(err => {
      console.error(err);
      next();
  });
    // next();
});
router.afterEach(() => {
  NProgress.done();
});

Vue.prototype.$Dialog = Dialog;
Vue.prototype.$toast = Toast;
Vue.prototype.DefaultUrl = baseUrl;
Vue.config.productionTip = false;
//如果有错误，传送给后台
//系统错误捕获
const errorHandler = (error, vm,info)=>{
 //报错地址  1111,
 //报错内容  2222
 //报错页面  3333
  var errort_txt='';
  error=error.toString();
  console.error('报错异常');

   errort_txt+='1111:'+location.href;
   errort_txt+='2222:'+error;
   errort_txt+='3333:'+info;
   $axios.get(`/api/log/index?log=${errort_txt}`).then(response => {
    console.log(errort_txt);
  }).catch(err => {
    console.error('失败请求'+err);
  });
}

Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js